import { Typography, Box, Chip } from "@mui/material";
import type { IComment } from "../../../../../types/comment";
import { type GridColDef } from "@mui/x-data-grid";
import { handleCheckToggle } from "../utils/handleCommentCheckboxToggle";
import Checkbox from "@mui/material/Checkbox";

import { StatusUpdate } from "./StatusUpdate";
import { CommentsTableActions } from "./CommentsTableActions";

interface CommentsTableColumnProps {
  toggleChecked: () => void;
  checkedCommentsID: string[];
  refreshComments: (comment: IComment, isDeleting: boolean) => void;
  setCheckedCommentsID: React.Dispatch<React.SetStateAction<string[]>>;
  fetchApprovedComments: () => Promise<void>;
}

export const CommentsTableColumn = ({
  toggleChecked,
  setCheckedCommentsID,
  checkedCommentsID,
  refreshComments,
  fetchApprovedComments,
}: CommentsTableColumnProps): GridColDef<IComment>[] => {
  const columns: GridColDef<IComment>[] = [
    {
      field: "check",
      width: 115,
      renderHeader() {
        return <Checkbox onClick={toggleChecked} />;
      },
      renderCell(params) {
        return (
          <Checkbox
            checked={checkedCommentsID.some((id) => id === params.row.id)}
            onClick={() =>
              handleCheckToggle(
                params.row,
                checkedCommentsID,
                setCheckedCommentsID
              )
            }
          />
        );
      },
    },
    {
      field: "content",
      headerName: "Comment",
      disableColumnMenu: true,
      flex: 1,
      renderCell: (params) => {
        const comment: IComment = params.row;
        return (
          <StatusUpdate
            comment={comment}
            refreshComments={refreshComments}
            fetchApprovedComments={fetchApprovedComments}
          />
        );
      },
    },
    {
      field: "author",
      headerName: "Author",
      flex: 1,
      renderCell: (params) => {
        return (
          <Box sx={{ mt: 1, mb: 1 }}>
            <Typography variant="body2" fontWeight={"bold"}>
              {params.row.author}
            </Typography>
            <Typography variant="body2" fontWeight={"medium"}>
              {params.row.authorEmail}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "timestamp",
      headerName: "Time",
      flex: 1,
      renderCell: (params) => {
        return (
          <Typography sx={{ mt: 2, mb: 1 }} variant="body2" fontWeight={"bold"}>
            {params.row.timestamp}
          </Typography>
        );
      },
    },
    {
      field: "is_approved",
      headerName: "Status",
      width: 120,
      renderCell: (params) => {
        return (
          <Typography
            sx={{ mt: 2, mb: 1 }}
            variant="body2"
            fontWeight={"medium"}
          >
            <Chip
              label={params.row.isApproved ? "Approved" : "Pending"}
              sx={{
                bgcolor: params.row.isApproved ? "#4BA663" : "#F79E1B40",
              }}
            />
          </Typography>
        );
      },
    },
    {
      field: "action",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => {
        return <CommentsTableActions comment={params.row} />;
      },
    },
  ];

  return columns;
};
